<template>
  <div class="container-fluid talent-query-page">
    <loading :active.sync="isLoading" loader="dots"></loading>

    <img class="banner" src="@/assets/img/query.png" alt="" />
    <div class="title">查詢人才</div>
    <div class="search-input-wrap" style="margin-bottom: 10px">
      <input
        type="text"
        placeholder="請輸入關鍵字，如姓名、Email、手機、工作經歷、學歷"
        v-model.trim="QueryKeyword"
        @keyup.enter="sendQueryValue()"
      />
    </div>
    <div style="text-align: left; font-size: 15px; margin-bottom: 10px;">
      ※ 如要查詢人才姓名含「黃」與「王」任一個關鍵字的資料，便可使用「黃|王」的語法進行查詢。
    </div>
    <button
      type="button"
      class="btn btn-primary"
      style="margin-left: 10px"
      @click="sendQueryValue"
    >
      {{ i18n("Buttons.Search") }}
    </button>

    <div
      class="modal fade"
      id="searchExplanModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            進階搜尋說明
            <div @click.prevent="showTornadoExplanModal" style="float: right">
              <span style="font-size: 0.8em">關於進階搜尋</span>
              <span class="explanation">?</span>
            </div>
          </div>
          <div class="modal-body">
            <div class="tip-title">1.複合式查詢</div>

            <div class="tip-sub-title">布林運算式查詢</div>
            <div class="tip-sub-desc">
              在查詢條件內使用布林符號「&amp;」(AND運算)、「|」(OR運算)及「!」(NOT運算)，將可以使得查詢結果更為精準。
            </div>
            <table class="tip-table">
              <tbody>
                <tr>
                  <th>搜尋</th>
                  <th>說明</th>
                </tr>
                <tr>
                  <td>&amp;</td>
                  <td>
                    如要查內文同時含有「蛋捲」與「冰淇淋」兩個關鍵字的資料，便可使用「蛋捲&amp;冰淇淋」的語法進行查詢。
                  </td>
                </tr>
                <tr>
                  <td>|</td>
                  <td>
                    如要查內文同時含有「蛋捲」與「冰淇淋」任一個關鍵字的資料，便可使用「蛋捲|冰淇淋」的語法進行查詢。
                  </td>
                </tr>
                <tr>
                  <td>!</td>
                  <td>
                    如要查內文含有關鍵字「蛋捲」但不包含關鍵字「冰淇淋」的資料，便可使用「蛋捲!冰淇淋」的語法進行查詢。
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="tip-sub-title">中文萬用字元</div>
            <div class="tip-sub-desc">
              欲使用不完整的資訊查詢時，可用「?」代替一個字，如輸入「?捲風」、「龍捲?」均能查詢「龍捲風」的相關資訊。或者所知的資訊更不完整時，可用「*」代替零到多個字進行查詢，如：輸入「tor*」進行查詢時，可搜尋出「tornado」、「torch」、或「torment」等相關結果
            </div>

            <div class="tip-title">2.搜尋模式</div>
            <table class="tip-table">
              <tbody>
                <tr>
                  <th>模式</th>
                  <th>說明</th>
                  <th>範例</th>
                </tr>
                <tr>
                  <td>完全符合</td>
                  <td>會根據輸入的關鍵字進行完全比對</td>
                  <td>輸入「文管」，能完全符合「文管」的關鍵字</td>
                </tr>
                <tr>
                  <td>模糊搜尋</td>
                  <td>可搜尋出語意相近的資訊</td>
                  <td>輸入「文建會」可以查到「文化建設委員會」的搜尋結果</td>
                </tr>
                <tr>
                  <td>英文詞性代換</td>
                  <td>
                    針對英文因詞性、時態不同產生字尾變化，進行自動擴展及替換
                  </td>
                  <td>輸入「swimming」能找到「swim」</td>
                </tr>
                <tr>
                  <td>同音字搜尋</td>
                  <td>會搜尋出中文拼音相同的詞彙</td>
                  <td>輸入「臺灣」，能同時也找到「台灣」的內容</td>
                </tr>
                <tr>
                  <td>同義詞搜尋</td>
                  <td>也會搜尋出與關鍵字同義的字詞結果</td>
                  <td>輸入「製造」，能同時也找到「製作」</td>
                </tr>
                <tr>
                  <td>簡繁對譯搜尋</td>
                  <td>
                    會進行繁體與簡體轉換，並使用繁體關鍵字與簡體關鍵字進行搜尋
                  </td>
                  <td>輸入「印表機」，能同時也找到「打印机」</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="tornadoExplanModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">進階查詢</div>
          <div class="modal-body">
            <div class="desc">
              <span>
                尚未開通此功能<br />
                套用龍捲風加值搜尋時，可額外搜尋技能專長、證照、學校、科系、地址<br />
                讓您的搜尋結果更加精確。<br />
                歡迎點選下方按鈕開通此功能。
              </span>
            </div>

            <img
              style="width: 100%"
              src="@/assets/img/explan/tornado/messageImage_01.jpg"
              alt=""
            />

            <img
              style="width: 100%"
              src="@/assets/img/explan/tornado/messageImage_02.jpg"
              alt=""
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="enableFunction"
            >
              開通此功能
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";

export default {
  name: "Query",
  data() {
    return {
      QueryKeyword: null,
    };
  },

  methods: {
    showTornadoExplanModal() {
      $("#tornadoExplanModal").modal("show");
    },

    // 快速查詢 API
    sendQueryValue() {
      this.updateLoading(true);
      localStorage.setItem("QUERY", JSON.stringify(this.QueryKeyword));
      localStorage.setItem("ORIGIN_PATH", this.$route.name.split(",")[1]);
      this.$router.push({ path: "/manager/talent/queryresult" });
    },

    // 開通功能
    enableFunction() {
      const vm = this;
      const api = `${window.endpoints.api}/Notice/AskForDLC`;

      const data = {
        Function: "龍捲風搜尋引擎",
        MailSenderGuid: vm.$cookies.get("userId"),
      };

      this.updateLoading(true);
      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            this.updateLoading(false);
            vm.$notify({
              title: "成功",
              message: "已將您的需求通知業務，請靜候消息。",
              type: "success",
              duration: 3000,
            });
          }
        })
        .catch((error) => {
          this.updateLoading(false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },
};
</script>

<style lang="scss" scoped>
.talent-query-page {
  max-width: 480px;
  margin: 0 auto;
  text-align: center;

  .title {
    background-color: #dfe8ff;
    border-radius: 25px;
    margin-bottom: 10px;
  }
  .banner {
    max-width: 100%;
    width: 260px;
    margin: 30px 0;
  }
  .search-input-wrap {
    display: flex;

    input {
      border: none;
      height: 40px;
      line-height: 40px;
      padding: 0 15px;
      border-radius: 5px;
      flex: 1;
      min-width: 1px;
    }
    .btn {
      margin-left: 5px;
    }
  }

  .separate {
    display: flex;
    align-items: center;
    margin: 40px 0;

    span {
      margin: 0 15px;
    }
    &:after,
    &:before {
      content: "";
      flex: 1;
      height: 1px;
      background-color: #c7c7c7;
    }
  }
  .history {
    a {
      display: block;
      background-color: #fff;
      margin-bottom: 10px;
      text-align: left;
      padding: 10px 15px;
      border-radius: 25px;
      color: #000;
      i {
        margin-right: 10px;
      }
    }
  }
}

.desc {
  background-image: url("https://tornado.opview.com.tw/wp-content/uploads/2020/04/34401187_xxl.jpg");
  background-size: cover;
  background-position: center center;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1;
  }
  span {
    position: relative;
    z-index: 2;
    color: #fff;
    padding: 30px;
    display: block;
  }
}

#searchExplanModal {
  .tip-title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .tip-sub-title {
    color: #ff6a00;
  }
  .tip-sub-desc {
    opacity: 0.8;
    margin-bottom: 20px;
    font-size: 0.9em;
  }
  .tip-table {
    font-size: 0.9em;
    margin-bottom: 20px;
    th {
      background-color: #5380f7;
      color: #fff;
      white-space: nowrap;
      text-align: center;
      border: 1px solid #ccc;
      padding: 3px;
    }
    td {
      border: 1px solid #ccc;
      padding: 3px;
    }
  }
}
</style>
